// Тип сущности в ссылке системного сообщения чата (Link.Type).
export enum ChatLinkType {
    Client = 0,
    Project = 1,
}
